<!--
 * @Author: 汪俊洪
 * @Date: 2024-04-23 16:55:45
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-04-25 09:47:06
 * @Description:
-->
<template>
  <div class="wxLoginPage" v-loading="loading"></div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      loading: true,
      wxInfo: {}
    }
  },
  methods: {
    getWxOpenPlatformWebsiteAppLoginCredentials (code) {
      this.$http
        .post(`/auth/getWxOpenPlatformWebsiteAppLoginCredentials?code=${code}`)
        .then(({ data: res }) => {
          console.log('res', res)
          if (res.code === 0) {
            this.wxInfo = res.data
            sessionStorage.setItem('wxInfo', JSON.stringify(res.data))
            this.weChatWxOpenPlatformWebsiteAppLogin()
          }
        })
    },
    weChatWxOpenPlatformWebsiteAppLogin () {
      const {
        accessTokenCiphertext,
        openPlatformWebsiteAppOpenidCiphertext,
        refreshTokeCiphertext,
        scope
      } = this.wxInfo
      let url = `/auth/weChatWxOpenPlatformWebsiteAppLogin?accessTokenCiphertext=${accessTokenCiphertext}&openPlatformWebsiteAppOpenidCiphertext=${openPlatformWebsiteAppOpenidCiphertext}&refreshTokeCiphertext=${refreshTokeCiphertext}&scope=${scope}`
      this.$http.post(url).then(({ data: res }) => {
        console.log('res2', res)
        sessionStorage.setItem('res2', JSON.stringify(res.data))
        if (res.code === 0) {
          // 没有登录的
          if (res.data.status === 0) {
            parent.location.href = '/wxReg'
          } else {
            // 登录成功
            Cookies.set('access_token_shop', res.data.oAuth2AccessToken.access_token)
            Cookies.set('username_shop', res.data.oAuth2AccessToken.username)
            // 学习平台cookie登录共享
            Cookies.set('access_token_shop', res.data.oAuth2AccessToken.access_token, {
              domain: location.origin.includes('plantmate.supcon.com') ? '.supcon.com' : '.plantmate.com'
            })
            Cookies.set('username_shop', res.data.oAuth2AccessToken.username, {
              domain: location.origin.includes('plantmate.supcon.com') ? '.supcon.com' : '.plantmate.com'
            })
            parent.location.href = '/'
          }
        }
      })
    }
  },
  created () {
    let code = this.$route.query.code
    if (code) {
      this.getWxOpenPlatformWebsiteAppLoginCredentials(code)
    }
  }
}
</script>

<style lang="scss" scoped>
.wxLoginPage {
  height: 300px;
  background: #e5e5e5;
}
</style>
